import dayjs from "dayjs";
import type { NextPageContext } from "next";
import hash from "string-hash";
import { decode } from "universal-base64";
import Cookies from "universal-cookie";

import { config, STAGE } from "utils/config.utils";

const cookieOpts = {
  path: "/",
  domain:
    STAGE !== "prod" &&
    typeof window !== "undefined" &&
    // Exclude localhost or local domains
    window.location.host.split(".").length > 1
      ? `${window.location.host.replace(/:[0-9]+$/, "")}`
      : config.cookie_domain,
  secure: true,
};

export function setCookie(key: string, value: string, expires?: Date) {
  if (typeof window !== "undefined") {
    const cookies = new Cookies();
    cookies.set(key, value, {
      ...cookieOpts,
      domain: cookieOpts.domain || undefined,
      expires,
    });

    // Store a copy in session storage (not shared between tabs)
    if (key === config.session_cookie) {
      sessionStorage.setItem(key, String(hash(value)));
    }
  }
}

export function removeCookie(key: string) {
  if (typeof window !== "undefined") {
    const cookies = new Cookies();
    cookies.remove(key, {
      ...cookieOpts,
      domain: cookieOpts.domain || undefined,
    });
  }
}

export function getCookie(key: string, context?: NextPageContext) {
  const headers = context?.req?.headers || {};
  const cookies = new Cookies(headers.cookie || undefined);

  const value = cookies.get(key);

  if (typeof window !== "undefined" && key === config.session_cookie) {
    const sessionValue = sessionStorage.getItem(key);

    // Token has been changed by another tab
    if (value && sessionValue && String(hash(value)) !== sessionValue) {
      // Update session storage with new hash
      sessionStorage.setItem(key, String(hash(value)));

      // reload the page to avoid the issue of the token being different in the other tab
      window.location.reload();

      return null;
    }
  }

  return value;
}

export const setToken = (token: string) =>
  setCookie(
    config.session_cookie,
    token,
    dayjs().add(config.session_cookie_expires_in_days, "day").toDate(),
  );

export function getToken(queryToken?: string) {
  if (queryToken) {
    try {
      const tokenJSON = JSON.parse(decode(queryToken));
      const token = tokenJSON?.token || undefined;
      if (token) {
        setCookie(config.session_cookie, token);
      }

      return token;
    } catch (error) {
      console.error(error);
    }
  }

  return (
    getCookie(config.b2b_session_cookie) || getCookie(config.session_cookie)
  );
}
